import React, { useEffect, useState, useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  Form,
  Input,
  FormFeedback,
  Label,
  Col,
} from "reactstrap";
import Select from "react-select";
import {
  resourcesConcesionarios,
  resourcesPasajeros,
  resourcesRoutes,
} from "../../../helpers/backend_helper";
import { getStorageCompany } from "../../../helpers/api_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import classNames from "classnames";
import NibbleInput from "../../../components/Fields/NibbleInput";

const AddUpdModal = ({
  modal,
  setModal,
  items,
  setItems,
  setItem,
  item,
  authUser,
}) => {
  const company = getStorageCompany();
  const [routes, setRoutes] = useState([]);
  const [errors, setErrors] = useState([]);
  const [units, setUnits] = useState([]);
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setModal({ ...modal, show: false, update: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: { ...item },
    validationSchema: Yup.object({
      name: Yup.string().nullable(true).required("Requerido"),
      lname1: Yup.string().nullable(true).required("Requerido"),
      lname2: Yup.string().nullable(true),
      is_student: Yup.bool().nullable(true),
      is_third_age: Yup.bool().nullable(true),
      is_handicapped: Yup.bool().nullable(true),
      rfid: Yup.string().nullable(true).required("Requerido"),
      blood_type: Yup.string().nullable(true).required("Requerido"),
      phone: Yup.string().nullable().matches(/^\d{10}$/, 'Teléfono debe contener 10 dígitos'),
    }),
    onSubmit: async (values) => {
      await save(values);
    },
  });

  const save = async (data) => {
    try {
      setLoading(true);
      const response = modal.update
        ? await resourcesPasajeros("put", data, data.id)
        : await resourcesPasajeros("post", data);
      responseAction(response);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  const responseAction = (response) => {
    if (response.status) {
      const newItem = response.pasajero;
      let array = [];
      if (modal.update) {
        array = items.map((item) => (item.id !== newItem.id ? item : newItem));
      } else {
        array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
      }
      setItems(array);
      handleClose();
      setLoading(false);
    } else {
      setLoading(false);
      setErrors(response.response.data.errors);
    }
  };

  useEffect(() => {
    if (authUser.profile_id != 3) {
      resourcesRoutes("get", {}).then((response) => {
        setRoutes(response.data);
      });
    }
  }, []);

  return (
    <div>
      <Modal isOpen={modal.show}>
        <ModalHeader className="bg-primary">
          {modal.update ? "Editar" : "Agregar"} Pasajero
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              {authUser.profile_id == 2 && (
                <div className="col-sm-12">
                  <label className="form-label">Ruta:</label>
                  <Select
                    className={classNames({ 'is-invalid': (validation.touched.route_id && validation.errors.route_id) })}
                    classNamePrefix="select"
                    isClearable={true}
                    value={routes.filter(e => e.id == validation.values.route_id)[0] ?? null}
                    isSearchable={true}
                    getOptionLabel={(option) => `${option.name}`}
                    getOptionValue={(option) => `${option.id}`}
                    name="route_id"
                    options={routes}
                    onChange={(option, meta) => { validation.setFieldValue('route_id', option.id, true) }}
                  />
                  <FormFeedback type="invalid">{validation.errors.route_id}</FormFeedback>
                </div>
              )}
              <NibbleInput
                md={12}
                label="Nombre(s):"
                fieldName="name"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Apellido paterno:"
                fieldName="lname1"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Apellido materno:"
                fieldName="lname2"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="ID tarjeta:"
                fieldName="rfid"
                fieldType="text"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Tipo sanguíneo:"
                fieldName="blood_type"
                fieldType="select"
                selectItems={[
                  { id: 'O-', name: 'O-' },
                  { id: 'O+', name: 'O+' },
                  { id: 'A-', name: 'A-' },
                  { id: 'A+', name: 'A+' },
                  { id: 'B-', name: 'B-' },
                  { id: 'B+', name: 'B+' },
                  { id: 'AB-', name: 'AB-' },
                  { id: 'AB+', name: 'AB+' },
                ]}
                validation={validation}
              />
              <NibbleInput
                md={12}
                label="Teléfono:"
                fieldName="phone"
                fieldType="number"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Es estudiante:"
                fieldName="is_student"
                fieldType="boolean-switch"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Es 3ra Edad:"
                fieldName="is_third_age"
                fieldType="boolean-switch"
                validation={validation}
              />
              <NibbleInput
                md={6}
                label="Es Discapacitado:"
                fieldName="is_handicapped"
                fieldType="boolean-switch"
                validation={validation}
              />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cancelar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default AddUpdModal;
